module.exports = __webpack_public_path__ + "static/media/brush_6.46d3474c.png";